var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Create Booking")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Booking Entry List"
    },
    on: {
      "click": _vm.showBookingType
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('form', [(_vm.showFlag == false) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "clearable": false,
      "name": "CompanyList",
      "placeholder": "Select Company Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.disableFileds
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  }), _vm._v("\n              "), (_vm.showFlag == false && _vm.Status == 'Pending') ? _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "padding-top": "8px"
    },
    attrs: {
      "title": "Refresh"
    },
    on: {
      "click": _vm.refreshPage
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))])], 1), _vm._v(" "), (_vm.showFlag == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbNo),
      expression: "awbNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "awbNo",
      "id": "awbNo",
      "placeholder": "Enter AWB Number",
      "maxlength": 16,
      "disabled": _vm.checked == false
    },
    domProps: {
      "value": (_vm.awbNo)
    },
    on: {
      "keyup": _vm.selectCheckbox,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('awbNo')))])], 1) : _vm._e(), _vm._v(" "), (_vm.Status != 'Pending') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-podcast' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Status),
      expression: "Status"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Status",
      "id": "Status",
      "placeholder": "Enter Status",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.Status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Status = $event.target.value
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.checkflag == false && _vm.Status == 'Pending') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "margin-top": "-2px",
      "width": "10%",
      "z-index": "2",
      "position": "unset"
    },
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "value": "true",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, "true") > -1 : (_vm.checked)
    },
    on: {
      "click": _vm.selectCheckbox,
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px",
      "font-size": "16px",
      "font-weight": "500"
    }
  }, [_c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("   "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("Enter AWB")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('checkbox')),
      expression: "errors.has('checkbox')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('checkbox')))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showFlag == false) ? _c('div', [(_vm.userRoleFlag != 1 && _vm.bookingid == '') ? _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "float": "right",
      "margin-top": "5px"
    }
  }, [_c('span', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit",
      "title": "Data Upload",
      "disabled": (_vm.showFlag == true || _vm.bookingid != '') ? true : false
    },
    on: {
      "click": _vm.UploadData
    }
  }, [_vm._v("Data Upload "), _c('i', {
    staticClass: "fa fa-upload"
  })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showFlag == false && (_vm.Status != 'Pending')) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.bookingData.bookingmode == 'To Pay' && _vm.showCashMemoButton == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Upload FTC Cash Memo"
    },
    on: {
      "click": _vm.openFtcModal
    }
  }, [_vm._v("Upload FTC Cash Memo "), _c('i', {
    staticClass: "fa fa-upload"
  })]) : _vm._e(), _vm._v("  \n        "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Print AWB"
    },
    on: {
      "click": _vm.openPrintAWBModal
    }
  }, [_vm._v("Print AWB "), _c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v("  \n        "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Print MPS"
    },
    on: {
      "click": _vm.openPrintMPSModal
    }
  }, [_vm._v("Print MPS "), _c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v("  \n        "), (_vm.rateCardData) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "View Rate Card"
    },
    on: {
      "click": function($event) {
        _vm.openViewRateCard = true
      }
    }
  }, [_vm._v("View Rate Card "), _c('i', {
    staticClass: "fa fa-credit-card"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showFlag == false) ? _c('div', [_c('information', {
    ref: "moveToNext",
    attrs: {
      "bookingData": _vm.bookingData,
      "status": _vm.Status
    },
    on: {
      "savebooking": _vm.saveBooking
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFlag == true) ? _c('div', [_c('data-upload', {
    attrs: {
      "Clientlist": _vm.Clientlist
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.PrintMPSModal = false
      }
    },
    model: {
      value: (_vm.PrintMPSModal),
      callback: function($$v) {
        _vm.PrintMPSModal = $$v
      },
      expression: "PrintMPSModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Print MPS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrintMPSModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.showMPSFlag == true) ? _c('fieldset', [_c('printmps', {
    attrs: {
      "bookingdata": _vm.bookingData
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.PrintAWBModal = false
      }
    },
    model: {
      value: (_vm.PrintAWBModal),
      callback: function($$v) {
        _vm.PrintAWBModal = $$v
      },
      expression: "PrintAWBModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Print AWB"
    },
    on: {
      "click": _vm.printAWBPage
    }
  }, [_vm._v("Print AWB "), _c('i', {
    staticClass: "fa fa-print"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrintAWBModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.showLRFlag == true) ? _c('div', [_c('LR-Copy', {
    attrs: {
      "selectedData": _vm.LRCopyawbdata
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.FtcModal = false
      }
    },
    model: {
      value: (_vm.FtcModal),
      callback: function($$v) {
        _vm.FtcModal = $$v
      },
      expression: "FtcModal"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60"
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Upload/View FTC Cash Memo ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeFtcModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.allowimageupload == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    attrs: {
      "for": "ftccashmemeo"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "font-size": "1.5em"
    },
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "ftccashmemeo",
      "name": "ftccashmemeo",
      "accept": ".jpeg,.jpg,.png,.pdf,.doc,.docx",
      "multiple": "multiple",
      "type": "file"
    },
    on: {
      "change": _vm.UploadFtcCashMemo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n        " + _vm._s(_vm.filename) + "\n      ")]), _vm._v(" "), (_vm.filename) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearFtcModal
    }
  }, [_c('strong', [_vm._v("x")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("View Uploaded File\n                    "), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(_vm._s(_vm.downloadmessage))])]), _vm._v(" "), (_vm.uploadedDoc) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "1.5rem",
      "padding-left": "-16",
      "padding-top": "16px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Download Image"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.uploadedDoc)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "float": "right",
      "padding-right": "16px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Save",
      "disabled": !_vm.filename
    },
    on: {
      "click": function($event) {
        _vm.SaveFtcCashMemo()
      }
    }
  }, [_vm._v(" Save")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeFtcModal()
      }
    }
  }, [_vm._v("Cancel")])])])])], 1)], 1), _vm._v(" "), (_vm.rateCardData) ? _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.PrintAWBModal = false
      }
    },
    model: {
      value: (_vm.openViewRateCard),
      callback: function($$v) {
        _vm.openViewRateCard = $$v
      },
      expression: "openViewRateCard"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n        Rate Break Up\n        "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.openViewRateCard = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-8-text-center",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Base Freight")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.basefreight).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Terminal charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.originterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Terminal Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.destinationterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Other Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.othercharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges origin ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.originoperatorcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges destination ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.destinationoperatorcharges.toFixed(2))))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Extra Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.extracharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-warning"
  }, [_vm._v("Total Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-warning"
  }, [_vm._v(_vm._s(parseFloat(_vm.totalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-success"
  }, [_vm._v("Total charges + GST (18%) ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-success"
  }, [_vm._v(_vm._s(parseFloat(_vm.totalcharges + _vm.gst).toFixed(2)))])])])])])])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1503c8ec","hasScoped":true}!./src/modules/cargobooking/views/booking/Createbookingtype/Createbookingtype.component.html
// module id = 1185
// module chunks = 3